/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Freegamesitemtitle3Inputs */

const id_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis`)
};

const ms_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma`)
};

const da_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Spil`)
};

const de_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Spiele`)
};

const en_us2_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const es_es2_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis`)
};

const es_mx2_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis`)
};

const fil_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Libreng Laro`)
};

const fr_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits`)
};

const it_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi Gratis`)
};

const hu_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játékok`)
};

const nl_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Games`)
};

const no_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spill`)
};

const pl_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry`)
};

const pt_br2_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos Grátis`)
};

const pt_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis`)
};

const ro_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite`)
};

const fi_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaiset pelit`)
};

const sv_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spel`)
};

const vi_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí`)
};

const tr_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyunlar`)
};

const cs_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry zdarma`)
};

const bg_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри`)
};

const ru_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные игры`)
};

const uk_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовні ігри`)
};

const ar_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ألعاب مجانية`)
};

const hi_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम`)
};

const th_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรี`)
};

const ja_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム`)
};

const zh_cn2_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费游戏`)
};

const zh_hant1_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費遊戲`)
};

const ko_nav_freegamesitemtitle3 = /** @type {(inputs: Nav_Freegamesitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임`)
};

/**
* | output |
* | --- |
* | "Free Games" |
*
* @param {Nav_Freegamesitemtitle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_freegamesitemtitle3 = /** @type {((inputs?: Nav_Freegamesitemtitle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Freegamesitemtitle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_freegamesitemtitle3(inputs)
	if (locale === "ms") return ms_nav_freegamesitemtitle3(inputs)
	if (locale === "da") return da_nav_freegamesitemtitle3(inputs)
	if (locale === "de") return de_nav_freegamesitemtitle3(inputs)
	if (locale === "en-US") return en_us2_nav_freegamesitemtitle3(inputs)
	if (locale === "es-ES") return es_es2_nav_freegamesitemtitle3(inputs)
	if (locale === "es-MX") return es_mx2_nav_freegamesitemtitle3(inputs)
	if (locale === "fil") return fil_nav_freegamesitemtitle3(inputs)
	if (locale === "fr") return fr_nav_freegamesitemtitle3(inputs)
	if (locale === "it") return it_nav_freegamesitemtitle3(inputs)
	if (locale === "hu") return hu_nav_freegamesitemtitle3(inputs)
	if (locale === "nl") return nl_nav_freegamesitemtitle3(inputs)
	if (locale === "no") return no_nav_freegamesitemtitle3(inputs)
	if (locale === "pl") return pl_nav_freegamesitemtitle3(inputs)
	if (locale === "pt-BR") return pt_br2_nav_freegamesitemtitle3(inputs)
	if (locale === "pt") return pt_nav_freegamesitemtitle3(inputs)
	if (locale === "ro") return ro_nav_freegamesitemtitle3(inputs)
	if (locale === "fi") return fi_nav_freegamesitemtitle3(inputs)
	if (locale === "sv") return sv_nav_freegamesitemtitle3(inputs)
	if (locale === "vi") return vi_nav_freegamesitemtitle3(inputs)
	if (locale === "tr") return tr_nav_freegamesitemtitle3(inputs)
	if (locale === "cs") return cs_nav_freegamesitemtitle3(inputs)
	if (locale === "bg") return bg_nav_freegamesitemtitle3(inputs)
	if (locale === "ru") return ru_nav_freegamesitemtitle3(inputs)
	if (locale === "uk") return uk_nav_freegamesitemtitle3(inputs)
	if (locale === "ar") return ar_nav_freegamesitemtitle3(inputs)
	if (locale === "hi") return hi_nav_freegamesitemtitle3(inputs)
	if (locale === "th") return th_nav_freegamesitemtitle3(inputs)
	if (locale === "ja") return ja_nav_freegamesitemtitle3(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_freegamesitemtitle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_freegamesitemtitle3(inputs)
	return ko_nav_freegamesitemtitle3(inputs)
});
export { nav_freegamesitemtitle3 as "nav.freeGamesItemTitle" }